import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import './BooksAndJournals.css';

const BooksAndJournals = () => {
  const { t } = useTranslation();
  const [selectedCategory, setSelectedCategory] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [viewMode, setViewMode] = useState('grid'); // grid, list, timeline
  const [sortBy, setSortBy] = useState('title'); // title, category, year

  const booksData = [
    {
      category:'Faculty of Science Publications',
      title:'Hacettepe University Faculty of Science Journal',
      url:'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/kitap.png',
      pdfUrl:'https://fs.hacettepe.edu.tr/fenyeni/dosyalar/0-birle%C5%9Ftirildi_compressed.pdf',
      description: `As Hacettepe University Faculty of Science, we are sharing with you our faculty's first scientific journal, which began publication in March 1971. This journal is a reflection of the Faculty of Science's deep-rooted academic tradition spanning more than half a century and its pursuit of scientific excellence. This historic work, prepared through the meticulous efforts of our expert academics, brings together developments in various disciplines of fundamental sciences, original research, and in-depth analyses. This journal, which represents our faculty's pioneering step in scientific publishing, has been a source of inspiration for generations and has made valuable contributions to the world of science. In the light of science, from the past to the future...`
    },
    { category:'Biology', title:'Ecology Prof. Dr. Nihat Şişli', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/ekoloji%20prof.dr.m.nihat%20%C5%9Fi%C5%9Fli.jpg' },
    { category:'Biology',title:'Evolution Prof. Dr. Nihat Şişli',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/evrim%20prof.dr.%20m.nihat%20%C5%9Fi%C5%9Fli.jpg' },
    { category:'Biology', title:'General Parasitology Prof. Dr. Mehmet Mihri Mimioğlu',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/genel%20parazitoloji%20prof.dr.mehmet%20mihri%20mimio%C4%9Flu.jpg' },
    { category:'Biology', title:'General Zoology Laboratory Guide',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/genel%20zooloji%20labaratuar%20k%C4%B1lavuzu%20dr.d%C3%BCrdane%20kolankaya-%20f%C3%BCs%C3%BCn%20erkakan-%20h%C3%BCseyin%20porsuk-%20nilg%C3%BCn%20karakoyunlu.jpg' },
    { category:'Biology', title:'Vertebrate Animals (Chordata) Systematics Assoc. Prof. Dr. Mustafa Kuru',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/omurgal%C4%B1%20hayvanlar%20(chordata)%20sistemati%C4%9Fi%20do%C3%A7.dr.mustafa%20kuru.jpg' },
    { category:'Biology', title:'Vertebrate Animals Systematics Assoc. Prof. Dr. Mustafa Kuru',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/omurgal%C4%B1%20hayvanlar%20sistemati%C4%9Fi%20do%C3%A7.dr.mustafa%20kuru.jpg' },
    { category:'Biology', title:'Freshwater Fishes of Turkey Catalog Assoc. Prof. Dr. Mustafa Kuru',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/t%C3%BCrkiye%20tatl%C4%B1su%20bal%C4%B1klar%C4%B1%20katalo%C4%9Fu%20do%C3%A7.dr.mustafa%20kuru.jpg' },
    { category:'Biology', title:'Rapidly Growing Sector in Turkey: An Overview of Bee Products Aslı Özkök',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/t%C3%BCrkiyede%20h%C4%B1zla%20b%C3%BCy%C3%BCyen%20sekt%C3%B6r%20ar%C4%B1%20%C3%BCr%C3%BCnlerine%20genel%20bir%20bak%C4%B1%C5%9F%20asl%C4%B1%20%C3%B6zk%C3%B6k.jpg' },
    { category:'Statistics', title:'Descriptive Statistics', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/betimsel%20istatistik%20yrd.do%C3%A7.dr%20t%C3%BClay%20sara%C3%A7ba%C5%9F%C4%B1%20-%20prof.dr.alaettin%20kutsal.jpg' },
    { category:'Statistics', title:'Linear Programming I', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/do%C4%9Grusal%20programlama%201%20yazan%20dr.g%C3%BCls%C3%B6m%20oral.jpg' },
    { category:'Statistics', title:'Statistical Theory and Applications', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/istatistik%20kuram%C4%B1%20ve%20uygulamalar%20do%C3%A7%20dr%20hayriye%20%C3%B6zden%20(ikinci%20bask%C4%B1).jpg' },
    { category:'Statistics', title:'Statistics (Definitions, History, Organizations, Publications, Education)',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/istatistik-%20dr%20alalettin%20kutsal%20dr%20%C3%B6niz%20toktam%C4%B1%C5%9F.jpg' },
    { category:'Statistics', title:'Probability and Mathematical Statistics (Expanded Second Edition)',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/olas%C4%B1l%C4%B1k%20ve%20matematiksel%20istatistik%20(geni%C5%9Fletilmi%C5%9F%20ikinci%20bask%C4%B1)%20do%C3%A7.dr.h.ceyhun%20inal%20-%20do%C3%A7.dr.s%C3%BCleyman%20g%C3%BCnay.jpg' },
    { category:'Statistics', title:'Applied Basic Statistics', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/istatistik/temel%20uygulamal%C4%B1%20istatistik%20dr.alaattin%20kutsal-dr.f.zehra%20muluk.jpg' },
    { category:'Statistics', title:'Introduction to Sampling Assoc. Prof. Dr. Hayriye Özden', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/%C3%B6rneklemeye%20giri%C5%9F%20do%C3%A7.dr.hayriye%20%C3%B6zden%20.jpg' },
    { category:'Mathematics', title:'Discrete Groups Turgut Başkan',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/ayr%C4%B1k%20gruplar%20(fuchs%20gruplar%C4%B1%20ve%20n.e.c%20gruplar%C4%B1)%20turgut%20ba%C5%9Fkan%20.jpg' },
    { category:'Mathematics', title:'Matrices Dr. Gülsüm Oral', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/matematik/matrisler%20dr.g%C3%BCls%C3%BCm%20oral.jpg' },
    { category:'Mathematics', title:'Some problems on non smooth analysis and mathematical economic by A.M.Rubinov', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/matematik/some%20problems%20on%20non%20smooth%20analys%C4%B1s%20and%20mathematical%20economic%20by%20a.m.rub%C4%B1nov.jpg' },
    { category:'Mathematics', title:'Abstract Algebra-1 Dr Fethi Çallıalp', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/matematik/soyut%20cebir-1%20dr%20fethi%20%C3%A7all%C4%B1alp.jpg' },
    { category:'Chemistry', title:'Cryogels and Monoliths ', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/cryogels%20and%20monol%C4%B1ths%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20bo%20mattiasson%20-adil%20denizli.jpg' },
    { category:'Chemistry', title:'Experimental Biochemistry - Assoc. Prof. Dr. Atilla Atalay', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/deneysel%20biyokimya%20do%C3%A7.dr.atilla%20atalay.jpg' },

    { category:'Chemistry', title:'AFFINITY CHROMATOGRAPHY AND RELATED TECHNIQUES Adil Denizli', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/aff%C4%B1n%C4%B1ty%20chromatography%20and%20related%20techn%C4%B1ques%20-adil%20denizli.jpg' },
    { category:'Chemistry', title:'AFFINITY SENSORS Adil Denizli', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/aff%C4%B1n%C4%B1ty%20sensors%20-adil%20denizli.jpg' },
    { category:'Chemistry', title:'Advanced Materials: Biomaterials and Nanomaterials Applications / Filiz Kuralay',url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/biyoloji/ileri%20malzemeler%20biyomalzeme%20ve%20nanomalzeme%20uygulamalar%C4%B1%20-filiz%20kuralay.jpg' },


    { category:'Chemistry', title:'Molecular Imprinting', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/molecular%20%C4%B1mpr%C4%B1nt%C4%B1ng%20adil%20denizli.jpg' },
    { category:'Chemistry', title:'particulate technology and applications - ali tuncel handan yavuz', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/part%C4%B1culate%20technology%20and%20appl%C4%B1cat%C4%B1ons%20-ali%20tuncel%20handan%20yavuz%20.jpg' },
    { category:'Chemistry', title:'Cryogels and Monoliths', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/3-Cryogels%20Book.jpg' },
    { category:'Chemistry', title:'Yüzey Plazmon Rezonans Sensörler', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/5-Y%C3%BCzey%20Plazmon%20Rezonans%20Book.jpg' },
    { category:'Chemistry', title:'Smart Biosensing Technologies: Past, Present and Future', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/6-Smart%20Biosensing%20Technologies%20Book.jpg' },
    { category:'Chemistry', title:'Advanced Electrochemistry', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/8-Advanced%20Electrochemistry%20Book.jpg' },
    { category:'Chemistry', title:'Nanomaterials: Fundamentals and Applications', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/9-Nanomaterials%20Book.jpg' },
    { category:'Chemistry', title:'Molecular Imprinting for Nanosensors and Other Sensing Applications', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/1-Molecular%20%C4%B0mprinting%20for%20Nanosensors%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Plasmonic Sensors and Applications', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/2-Plasmonic%20Sensors%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Nanosensors for Smart Agriculture', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/3-Nanosensors%20for%20Smart%20Agriculture%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Nano-Biosorbents for Decontamination of Water, Air, and Soil Pollution', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/4-Nanobiosorbents%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Biosensors for Virus Detection', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/5-Biosensors%20for%20Virus%20Detection%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Nanotechnology for Hematology, Blood Transfusion, and Artificial Blood', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/6-Nanotechnology%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Nanotechnology-Based Smart Remote Sensing Networks for Disaster Prevention', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/7-Smart%20Remote%20Sensing%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Biophysics at the Nanoscale / Applications of Functional Materials', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/8-Biophysics%20at%20the%20Nanoscale%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Plasmonic Nanosensors for Biological and Chemical Threats', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/9-Plasmonic%20Nanosensors%20for%20Biological%20Cover_page-0001.jpg' },
    { category:'Chemistry', title:'Proteomics', url:'https://fs.hacettepe.edu.tr/fenyeni/kitaplar/kimya/10-Proteomics%20Cover_page-0001.jpg' }
  ];

  // Benzersiz kategorileri al
  const categories = [...new Set(booksData.map(book => book.category))];

  // Filtreleme ve sıralama
  useEffect(() => {
    let filtered = booksData;

    // Kategori filtresi
    if (selectedCategory) {
      filtered = filtered.filter(book => book.category === selectedCategory);
    }

    // Arama filtresi
    if (searchTerm) {
      filtered = filtered.filter(book => 
        book.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        book.category.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Sıralama
    filtered.sort((a, b) => {
      if (sortBy === 'title') {
        return a.title.localeCompare(b.title);
      } else if (sortBy === 'category') {
        return a.category.localeCompare(b.category);
      }
      return 0;
    });

    setFilteredBooks(filtered);
  }, [selectedCategory, searchTerm, sortBy]);

  // Kitap açma fonksiyonu
  const openBook = (url) => {
    window.open(url, '_blank');
  };

  // Animasyon varyantları
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 30, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    }
  };

  return (
    <div className="books-journals-page">
      {/* Video Header */}
      <div className="video-header-container">
        <video
          className="video-header"
          autoPlay
          muted
          loop
          playsInline
        >
          <source src="/fenfakultesivideo.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="video-overlay">
          <div className="video-content">
            <motion.h1
              className="video-title"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.5 }}
            >
              {t('pages.booksJournals.pageTitle')}
            </motion.h1>
            <motion.p
              className="video-subtitle"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.8 }}
            >
              {t('pages.booksJournals.pageSubtitle')}
            </motion.p>
          </div>
        </div>
      </div>

      {/* Content Container */}
      <div className="books-content-container">
        {/* Hero Section */}
        <div className="books-hero">
          <div className="books-hero-bg">
            <div className="floating-books">
              {[...Array(8)].map((_, i) => (
                <div key={i} className={`floating-book book-${i + 1}`}>📚</div>
              ))}
            </div>
            <div className="knowledge-particles">
              {[...Array(15)].map((_, i) => (
                <div key={i} className={`particle particle-${i + 1}`}>📖</div>
              ))}
            </div>
          </div>
          
          <div className="books-hero-content">
            <motion.div 
              className="books-stats"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1, delay: 0.6 }}
            >
              <div className="stat-item">
                <div className="stat-number">{booksData.length}+</div>
                <div className="stat-label">{t('pages.booksJournals.totalWorks')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">{categories.length}</div>
                <div className="stat-label">{t('pages.booksJournals.academicFields')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">50+</div>
                <div className="stat-label">{t('pages.booksJournals.authorsEditors')}</div>
              </div>
            </motion.div>
          </div>
        </div>



      {/* Controls Section */}
      <motion.div 
        className="books-controls"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8, duration: 0.6 }}
      >
        {/* Search and Sort */}
        <div className="controls-row">
          <div className="search-container">
            <input
              type="text"
              placeholder={t('pages.booksJournals.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            <div className="search-icon">🔍</div>
          </div>

          <div className="view-controls">
            <select
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value)}
              className="sort-select"
            >
              <option value="title">{t('pages.booksJournals.sortByTitle')}</option>
              <option value="category">{t('pages.booksJournals.sortByCategory')}</option>
            </select>

            <div className="view-mode-buttons">
              <button 
                className={`view-btn ${viewMode === 'grid' ? 'active' : ''}`}
                onClick={() => setViewMode('grid')}
              >
                📋
              </button>
              <button 
                className={`view-btn ${viewMode === 'list' ? 'active' : ''}`}
                onClick={() => setViewMode('list')}
              >
                📋
              </button>
            </div>
          </div>
        </div>

        {/* Category Filter */}
        <div className="category-filter">
          <h3>{t('pages.booksJournals.academicFieldsLabel')}</h3>
          <div className="category-tags">
            <motion.button
              className={`category-tag ${selectedCategory === '' ? 'active' : ''}`}
              onClick={() => setSelectedCategory('')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {t('pages.booksJournals.all')}
              <span className="category-count">{booksData.length}</span>
            </motion.button>

            {categories.map((category, index) => (
              <motion.button
                key={category}
                className={`category-tag ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(selectedCategory === category ? '' : category)}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.1 * index }}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                {t(`pages.booksJournals.categories.${category}`)}
                <span className="category-count">
                  {booksData.filter(book => book.category === category).length}
                </span>
              </motion.button>
            ))}
          </div>
        </div>
      </motion.div>

      

      {/* Filter Info */}
      {selectedCategory && (
        <motion.div
          className="filter-info"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="filter-label">{t('pages.booksJournals.selectedField')}</span>
          <span className="filter-value">{t(`pages.booksJournals.categories.${selectedCategory}`)}</span>
          <span className="filter-count">({filteredBooks.length} {t('pages.booksJournals.works')})</span>
          <button
            className="clear-filter"
            onClick={() => setSelectedCategory('')}
          >
            {t('pages.booksJournals.clearFilter')}
          </button>
        </motion.div>
      )}

      {/* Books Grid */}
      <motion.div 
        className={`books-grid ${viewMode} ${selectedCategory ? 'filtered' : ''}`}
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <AnimatePresence>
          {filteredBooks.map((book, index) => (
            <motion.div
              key={`${book.category}-${book.title}-${index}`}
              className="book-card"
              variants={itemVariants}
              layout
              whileHover={{ 
                y: -10,
                boxShadow: "0 25px 50px rgba(0,0,0,0.2)"
              }}
              whileTap={{ scale: 0.98 }}
              onClick={() => openBook(book.pdfUrl || book.url)}
            >
              <div className="book-cover">
                <img
                  src={book.url}
                  alt={book.title}
                  onError={(e) => {
                    e.target.src = '/fenfakultesilogo.png';
                  }}
                />
                <div className="book-overlay">
                  <div className="book-category">{t(`pages.booksJournals.categories.${book.category}`)}</div>
                  <div className="open-book-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                </div>
              </div>
              
              <div className="book-content">
                <h3 className="book-title">{book.title}</h3>
                <div className="book-footer">
                  <span className="book-type">{t('pages.booksJournals.academicWork')}</span>
                  <span className="view-book">{t('pages.booksJournals.view')}</span>
                </div>
              </div>
              
              <div className="book-glow"></div>
            </motion.div>
          ))}
        </AnimatePresence>
      </motion.div>

      {/* No Results */}
      {filteredBooks.length === 0 && searchTerm && (
        <motion.div
          className="no-results"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          <div className="no-results-icon">📚</div>
          <h3>{t('pages.booksJournals.noBooksFound')}</h3>
          <p>{t('pages.booksJournals.noResults', { searchTerm })}</p>
        </motion.div>
      )}

      {/* Academic Impact Section */}
      <motion.div
        className="academic-impact"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
      >
        <h2>{t('pages.booksJournals.academicContribution')}</h2>
        <div className="impact-grid">
          <div className="impact-item">
            <div className="impact-icon">📖</div>
            <h4>{t('pages.booksJournals.books')}</h4>
            <p>{t('pages.booksJournals.booksDesc')}</p>
          </div>
          <div className="impact-item">
            <div className="impact-icon">📰</div>
            <h4>{t('pages.booksJournals.journals')}</h4>
            <p>{t('pages.booksJournals.journalsDesc')}</p>
          </div>
          <div className="impact-item">
            <div className="impact-icon">🎓</div>
            <h4>{t('pages.booksJournals.academicGuides')}</h4>
            <p>{t('pages.booksJournals.academicGuidesDesc')}</p>
          </div>
          <div className="impact-item">
            <div className="impact-icon">🌍</div>
            <h4>{t('pages.booksJournals.internationalCollab')}</h4>
            <p>{t('pages.booksJournals.internationalCollabDesc')}</p>
          </div>
        </div>
      </motion.div>
      </div>
    </div>
  );
};

export default BooksAndJournals; 